(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Label", [], factory);
	else if(typeof exports === 'object')
		exports["Label"] = factory();
	else
		root["Label"] = factory();
})(window, function() {
return 